import api from './api';

export const submitQuestionnaire = async <T>(questionnaireId: string, body: T) =>
  api.post(`/questionnaire/${questionnaireId}`, body);

export const checkUniqueEmail = async (email: string) => api.get(`/questionnaire/${email}`);

export const getQuestions = async (uid?: string | null) =>
  uid ? api.get(`/questionnaire/get-questions/${uid}`) : api.get('/questionnaire/get-questions');
